<template>
  <b-row class="px-2">
    <b-col
      :cols="12"
      :class="$style.leagueNameWrapper"
    >
      <TheRoundTitle
        :image="round.season.league.image_url"
        :league-name="round.season.league.name[$i18n.locale]"
        :round-name="round.name[$i18n.locale]"
      />
    </b-col>
    <b-col :cols="12">
      <b-container>
        <b-row>
          <b-col
            :cols="6"
            :class="[
              'd-flex flex-column justify-content-center py-2 pl-0',
              $style.leftColumn
            ]"
          >
            <RoundJackpot
              v-if="round.season.league.type === 1"
              :text="$t('jackpot')"
              :round-id="round.id"
              :league-type="1"
              :prizes="round.prizes"
            />
            <RoundJackpot
              v-else-if="round.jackpot"
              :text="$t('round-jackpot')"
              :round-id="round.id"
              :jackpot="round.jackpot"
            />
            <RoundJackpot
              v-else-if="round.season.league.minimum_jackpot && !isRoundClosed"
              :text="$t('guaranteed-jackpot')"
              :round-id="round.id"
              :jackpot="round.season.league.minimum_jackpot"
              guaranteed-jackpot
            />
          </b-col>
          <b-col
            :cols="6"
            :class="[
              'd-flex flex-column justify-content-center align-items-end py-2 pr-0',
              $style.rightColumn
            ]"
          >
            <div class="d-flex align-items-center flex-fill text-right">
              <div class="pr-2">
                <template v-if="round.status === roundStatuses.upcoming">
                  <span :class="$style.smallText">{{ $t('upcoming-in') }}</span>
                  <BaseCountdown :date="round.start" />
                </template>
                <template v-else>
                  <span :class="$style.smallText">{{ $t('round-status') }}</span>
                  <BaseBadge :variant="roundBadgeVariant">
                    {{ $t(`round.status.${round.status}`) }}
                  </BaseBadge>
                </template>
              </div>
              <font-awesome-icon
                :icon="['far', 'clock']"
                size="2x"
              />
            </div>
          </b-col>
        </b-row>
      </b-container>
    </b-col>
  </b-row>
</template>

<script>
import { ROUND_STATUSES } from '@/store/modules/rounds/index'
import BaseBadge from '@/components/Atoms/BaseBadge'
import BaseCountdown from '@/components/Atoms/BaseCountdown'
import RoundJackpot from '@/pages/RoundDetail/Components/Atoms/RoundJackpot'
import TheRoundTitle from '@/components/Molecules/TheRoundTitle'

export default {
  name: 'TheRoundInfoOverview',
  components: {
    TheRoundTitle,
    BaseCountdown,
    BaseBadge,
    RoundJackpot,
  },
  props: {
    round: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      roundStatuses: ROUND_STATUSES,
      isJackpotModalVisible: false,
    }
  },
  computed: {
    roundBadgeVariant() {
      switch (this.round.status) {
      case ROUND_STATUSES.live: return 'orange'
      case ROUND_STATUSES.upcoming: return 'light-gray'
      default: return 'gray'
      }
    },
    isRoundClosed() {
      return this.round.status === ROUND_STATUSES.closed
    },
  },
}
</script>

<style module lang="scss">
  @import '../../assets/scss/variables';
  .leagueNameWrapper {
    border-bottom: 4px solid $color-bleached-silk;
    .leagueLogo {
      max-width: 40px;
      max-height: 40px;
    }
  }
  .leftColumn {
    border-right: 2px solid $color-bleached-silk;
  }
  .rightColumn {
    border-left: 2px solid $color-bleached-silk;
  }
  .smallText {
    font-size: $font-size-small;
  }
  .roundName {
    color: $color-midnight-blue;
    font-weight: 600;
    font-size: $font-size-xlarge;
  }
</style>
